import { CarvanaTheme } from '@carvana/theme';
import styled from 'styled-components';

export const IconWrapper = styled.div`
  z-index: 1;
  margin-right: 75px;
  &:last-child {
    margin-right: 0px;
  }

  & > h2 {
    font-size: 17px;
    font-weight: bold;
    color: #183558;
    line-height: 24px;
    word-break: normal;
    text-align: center;
    top: 12px;
    position: relative;
  }
  @media (max-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    margin-right: 0;
    & > h2 {
      width: 136px;
      top: 12px;
      right: 16px;
      text-align: center;
      margin: 0;
      font-size: 17px;
      font-weight: bold;
    }
  }
`;

export const Icons = styled.div`
  margin: 50px auto 100px auto;
  width: 100%;
`;

export const IconContent = styled.div`
  width: 110px;
  height: 105px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  & > h3 {
    float: left;
    background: #00aed9;
    border-radius: 50%;
    width: 30px;
    height: 26px;
    color: white;
    position: relative;
    bottom: 39px;
    font-size: 12px;
    left: 4px;
    padding: 4px;
    text-align: center;
  }
  @media (max-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    width: 110px;
    height: 105px;
  }
`;

export const IconImage = styled.div`
  & > img {
    width: 70%;
  }
`;
